export function ReadOnlyIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M14.701 3.279a3 3 0 114.76 3.653l-4.056 5.286-1.608-1.19 1.975-2.574-1.6-1.2-1.982 2.583-1.607-1.19 1.989-2.593L11.7 5.4 9.736 8.019l-1.607-1.19 2.568-3.425.003-.004a.999.999 0 011.4-.2l1.69 1.267.911-1.188zm3.174 2.435a1 1 0 10-1.587-1.217l-.898 1.17 1.6 1.2.885-1.153zM19.095 16.197a1 1 0 11-1.19 1.607l-13.5-10a1 1 0 111.19-1.607l13.5 10zM8.147 11.82l1.608 1.19-1.969 2.566a1 1 0 00.177 1.396l.034.026a1 1 0 001.376-.204l1.989-2.593 1.607 1.191-2.01 2.62a3.001 3.001 0 01-3.251 1.044L7 20h12a1 1 0 110 2H5a1 1 0 01-.794-1.609l1.891-2.52a3.001 3.001 0 01.102-3.512l1.948-2.539z"
      ></path>
    </svg>
  );
}
